import { render, staticRenderFns } from "./SiloTransfer.vue?vue&type=template&id=74c458d8&scoped=true&"
import script from "./SiloTransfer.vue?vue&type=script&lang=ts&"
export * from "./SiloTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./SiloTransfer.vue?vue&type=style&index=0&id=74c458d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c458d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serveradmin/azuredevopsagent3/_work/14/s/kbs.frontend/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c458d8')) {
      api.createRecord('74c458d8', component.options)
    } else {
      api.reload('74c458d8', component.options)
    }
    module.hot.accept("./SiloTransfer.vue?vue&type=template&id=74c458d8&scoped=true&", function () {
      api.rerender('74c458d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SiloTransfer.vue"
export default component.exports